// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

ion-button.hub-led-trigger {
  --padding-start: 0;
  --padding-end: 0;
  --padding-top: 0;
  --padding-bottom: 0;
  margin: 0;
}

.hub-led-trigger__shell {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.6rem;
  height: 2.6rem;
  border: 1px solid rgba(var(--ion-text-color-rgb), 0.08);
  border-radius: 999px;
  background: rgba(var(--ion-background-color-rgb), 0.92);
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);
  backdrop-filter: blur(12px);
}

.hub-led-trigger__icon {
  font-size: 1.45rem;
}

.hub-led-trigger__icon--online {
  color: #16a34a;
}

.hub-led-trigger__icon--offline {
  color: #ef4444;
}

.hub-led-trigger__icon--sync {
  color: #f59e0b;
}

ion-content.hub-status-content {
  --background: transparent;
}

.hub-status-panel {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}

.hub-status-header {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.25rem 0.2rem 0.15rem;
}

.hub-status-header__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 12px;
  background: rgba(var(--ion-text-color-rgb), 0.06);
  font-size: 1rem;
}

.hub-status-header__body {
  min-width: 0;
}

.hub-status-header__eyebrow {
  margin: 0 0 0.05rem;
  color: rgba(var(--ion-text-color-rgb), 0.55);
  font-size: 0.66rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.hub-status-header h3 {
  margin: 0;
  color: var(--ion-text-color);
  font-size: 0.96rem;
  font-weight: 700;
  line-height: 1.15;
}

.hub-status-header small {
  display: block;
  margin-top: 0.12rem;
  color: rgba(var(--ion-text-color-rgb), 0.72);
  line-height: 1.3;
}

.hub-status-header__icon--online {
  background: rgba(22, 163, 74, 0.14);
  color: #16a34a;
}

.hub-status-header__icon--offline {
  background: rgba(239, 68, 68, 0.14);
  color: #ef4444;
}

.hub-status-header__icon--sync {
  background: rgba(245, 158, 11, 0.16);
  color: #f59e0b;
}

.hub-status-list {
  margin: 0;
  padding: 0;
  list-style: none;
  border: 1px solid rgba(var(--ion-text-color-rgb), 0.08);
  border-radius: 16px;
  overflow: hidden;
  background: rgba(var(--ion-background-color-rgb), 0.94);
}

.hub-status-row {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 0.55rem;
  padding: 0.56rem 0.72rem;
}

.hub-status-row + .hub-status-row {
  border-top: 1px solid rgba(var(--ion-text-color-rgb), 0.08);
}

.hub-status-row__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.65rem;
  height: 1.65rem;
  border-radius: 10px;
  background: rgba(var(--ion-text-color-rgb), 0.06);
  flex-shrink: 0;
  font-size: 0.88rem;
}

.hub-status-row__label {
  min-width: 0;
  color: var(--ion-text-color);
  font-size: 0.84rem;
  font-weight: 600;
  line-height: 1.2;
}

.hub-status-row__badge {
  padding: 0;
  background: transparent;
  font-size: 0.73rem;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
}

.hub-status-row--online .hub-status-row__icon {
  background: rgba(22, 163, 74, 0.12);
  color: #15803d;
}

.hub-status-row__badge--online {
  color: #15803d;
}

.hub-status-row--offline .hub-status-row__icon {
  background: rgba(239, 68, 68, 0.12);
  color: #dc2626;
}

.hub-status-row__badge--offline {
  color: #dc2626;
}

.hub-status-row--sync .hub-status-row__icon {
  background: rgba(245, 158, 11, 0.16);
  color: #d97706;
}

.hub-status-row__badge--sync {
  color: #d97706;
}

.hub-status-help {
  padding: 0.75rem 0.85rem;
  border: 1px solid rgba(239, 68, 68, 0.14);
  border-radius: 16px;
  background: rgba(239, 68, 68, 0.08);
}

.hub-status-help__title {
  margin: 0;
  color: #dc2626;
  font-size: 0.84rem;
  font-weight: 700;
}

.hub-status-help__list {
  margin: 0.5rem 0 0;
  padding-left: 1.1rem;
  color: rgba(var(--ion-text-color-rgb), 0.8);
  font-size: 0.8rem;
  line-height: 1.4;
}

.hub-status-help__list li + li {
  margin-top: 0.18rem;
}

@media (max-width: 640px) {
  .hub-status-panel {
    width: 100%;
  }
  .hub-status-row {
    padding: 0.52rem 0.65rem;
  }
  .hub-status-row__badge {
    font-size: 0.69rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/_components/header/hub-state-led/hub-state-led.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,uDAAA;EACA,oBAAA;EACA,uDAAA;EACA,8CAAA;EACA,2BAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,+BAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iDAAA;EACA,eAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;AACF;;AAEA;EACE,SAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,cAAA;EACA,mBAAA;EACA,4CAAA;EACA,gBAAA;AACF;;AAEA;EACE,mCAAA;EACA,cAAA;AACF;;AAEA;EACE,mCAAA;EACA,cAAA;AACF;;AAEA;EACE,oCAAA;EACA,cAAA;AACF;;AAEA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,uDAAA;EACA,mBAAA;EACA,gBAAA;EACA,uDAAA;AACF;;AAEA;EACE,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;AACF;;AAEA;EACE,2DAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,iDAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,YAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,UAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,mCAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,mCAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,oCAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,wBAAA;EACA,yCAAA;EACA,mBAAA;EACA,mCAAA;AACF;;AAEA;EACE,SAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,oBAAA;EACA,2CAAA;EACA,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE;IACE,WAAA;EACF;EAEA;IACE,wBAAA;EAAF;EAGA;IACE,kBAAA;EADF;AACF","sourcesContent":[":host {\n  display: block;\n}\n\nion-button.hub-led-trigger {\n  --padding-start: 0;\n  --padding-end: 0;\n  --padding-top: 0;\n  --padding-bottom: 0;\n  margin: 0;\n}\n\n.hub-led-trigger__shell {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.6rem;\n  height: 2.6rem;\n  border: 1px solid rgba(var(--ion-text-color-rgb), 0.08);\n  border-radius: 999px;\n  background: rgba(var(--ion-background-color-rgb), 0.92);\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);\n  backdrop-filter: blur(12px);\n}\n\n.hub-led-trigger__icon {\n  font-size: 1.45rem;\n}\n\n.hub-led-trigger__icon--online {\n  color: #16a34a;\n}\n\n.hub-led-trigger__icon--offline {\n  color: #ef4444;\n}\n\n.hub-led-trigger__icon--sync {\n  color: #f59e0b;\n}\n\nion-content.hub-status-content {\n  --background: transparent;\n}\n\n.hub-status-panel {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n}\n\n.hub-status-header {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  padding: 0.25rem 0.2rem 0.15rem;\n}\n\n.hub-status-header__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 12px;\n  background: rgba(var(--ion-text-color-rgb), 0.06);\n  font-size: 1rem;\n}\n\n.hub-status-header__body {\n  min-width: 0;\n}\n\n.hub-status-header__eyebrow {\n  margin: 0 0 0.05rem;\n  color: rgba(var(--ion-text-color-rgb), 0.55);\n  font-size: 0.66rem;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n\n.hub-status-header h3 {\n  margin: 0;\n  color: var(--ion-text-color);\n  font-size: 0.96rem;\n  font-weight: 700;\n  line-height: 1.15;\n}\n\n.hub-status-header small {\n  display: block;\n  margin-top: 0.12rem;\n  color: rgba(var(--ion-text-color-rgb), 0.72);\n  line-height: 1.3;\n}\n\n.hub-status-header__icon--online {\n  background: rgba(22, 163, 74, 0.14);\n  color: #16a34a;\n}\n\n.hub-status-header__icon--offline {\n  background: rgba(239, 68, 68, 0.14);\n  color: #ef4444;\n}\n\n.hub-status-header__icon--sync {\n  background: rgba(245, 158, 11, 0.16);\n  color: #f59e0b;\n}\n\n.hub-status-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  border: 1px solid rgba(var(--ion-text-color-rgb), 0.08);\n  border-radius: 16px;\n  overflow: hidden;\n  background: rgba(var(--ion-background-color-rgb), 0.94);\n}\n\n.hub-status-row {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n  gap: 0.55rem;\n  padding: 0.56rem 0.72rem;\n}\n\n.hub-status-row + .hub-status-row {\n  border-top: 1px solid rgba(var(--ion-text-color-rgb), 0.08);\n}\n\n.hub-status-row__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.65rem;\n  height: 1.65rem;\n  border-radius: 10px;\n  background: rgba(var(--ion-text-color-rgb), 0.06);\n  flex-shrink: 0;\n  font-size: 0.88rem;\n}\n\n.hub-status-row__label {\n  min-width: 0;\n  color: var(--ion-text-color);\n  font-size: 0.84rem;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.hub-status-row__badge {\n  padding: 0;\n  background: transparent;\n  font-size: 0.73rem;\n  font-weight: 700;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.hub-status-row--online .hub-status-row__icon {\n  background: rgba(22, 163, 74, 0.12);\n  color: #15803d;\n}\n\n.hub-status-row__badge--online {\n  color: #15803d;\n}\n\n.hub-status-row--offline .hub-status-row__icon {\n  background: rgba(239, 68, 68, 0.12);\n  color: #dc2626;\n}\n\n.hub-status-row__badge--offline {\n  color: #dc2626;\n}\n\n.hub-status-row--sync .hub-status-row__icon {\n  background: rgba(245, 158, 11, 0.16);\n  color: #d97706;\n}\n\n.hub-status-row__badge--sync {\n  color: #d97706;\n}\n\n.hub-status-help {\n  padding: 0.75rem 0.85rem;\n  border: 1px solid rgba(239, 68, 68, 0.14);\n  border-radius: 16px;\n  background: rgba(239, 68, 68, 0.08);\n}\n\n.hub-status-help__title {\n  margin: 0;\n  color: #dc2626;\n  font-size: 0.84rem;\n  font-weight: 700;\n}\n\n.hub-status-help__list {\n  margin: 0.5rem 0 0;\n  padding-left: 1.1rem;\n  color: rgba(var(--ion-text-color-rgb), 0.8);\n  font-size: 0.8rem;\n  line-height: 1.4;\n}\n\n.hub-status-help__list li + li {\n  margin-top: 0.18rem;\n}\n\n@media (max-width: 640px) {\n  .hub-status-panel {\n    width: 100%;\n  }\n\n  .hub-status-row {\n    padding: 0.52rem 0.65rem;\n  }\n\n  .hub-status-row__badge {\n    font-size: 0.69rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
